import { statusBgColors, statusLabels } from "@/constant/statusConstants";

import React from "react";

export default function StatusBadge({ status, statusLabelMap = null, statusBgColorMap = null }) {
  const grayGradient = "linear-gradient(90deg, #7f8c8d, #95a5a6)";

  statusBgColorMap = statusBgColorMap ?? statusBgColors;
  const background = statusBgColorMap[status] || grayGradient;

  statusLabelMap = statusLabelMap ?? statusLabels();
  const statusLabel = statusLabelMap[status] ?? "N/A";

  return (
    <div className="flex justify-center">
      <div
        className="w-[110px] max-w-[110px] flex justify-center text-white font-extralight items-center h-6 rounded"
        style={{ background }}
      >
        {statusLabel}
      </div>
    </div>
  );
}
